import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { ResetPassoword, reset_password } from "../actions/auth";
import Input from "../form-components/Input";
import { HomeWrapper } from "./Login";
import Eye from "../assets/eye.svg";
import { LOGOUT_MAINTAIN } from "../config/helper";

const ResetPasswordSchema = Yup.object().shape({
  password: Yup.string().required("Password is required")
    .min(8, "Password must be at least 8 characters.")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter.")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter.")
    .matches(/\d/, "Password must contain at least one number.")
    .matches(
      /[@$!%*?&#^()_\-+=]/,
      "Password must contain at least one special character."
    ),
  confirmPassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});
const ResetPasswordForm = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const resetPasswordRes = useSelector((state) => state?.auth?.reset_password);
  const query = new URLSearchParams(location.search);
  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: ResetPasswordSchema,
    onSubmit: (values) => {
      let password = values.password;
      dispatch(
        reset_password({
          password,
          email: query.get("email"),
          token: query.get("token"),
        })
      );
    },
  });

  useEffect(() => {
    localStorage.clear()
    dispatch({
      type: LOGOUT_MAINTAIN,
      payload: true,
    })
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (resetPasswordRes && resetPasswordRes.data?.status === true) {
      toast.success(resetPasswordRes?.data?.message)
      dispatch({ type: ResetPassoword.RESET });
      history.push("/thank-you", {
        email: query.get("email"),
        from: "reset_password",
      });
      formik.resetForm();
    }

    if (resetPasswordRes && resetPasswordRes.data?.status === false) {
      toast.error(resetPasswordRes?.data?.message);
      dispatch({ type: ResetPassoword.RESET });
    }
    // eslint-disable-next-line
  }, [resetPasswordRes]);

  return (
    <HomeWrapper>
      <form className="flex-center" onSubmit={formik.handleSubmit}>
        <div>
          <div className="head-sec">
            <h3 className="text-heading">Reset your password</h3>
            <span className="text-sub-heading mt1 mb1 w60">
              We will send you an email with a link to reset your password
            </span>
          </div>
          <Input
            placeholder={"Enter password"}
            name="password"
            type="password"
            formik={formik}
            icon={Eye}
          />
          <Input
            placeholder={"Enter Confirm Password"}
            name="confirmPassword"
            type="password"
            formik={formik}
            icon={Eye}
          />
          <div className="v-center mt2">
            <button
              className={`primary-btn mr1 ${resetPasswordRes?.loading ? "loadBtn" : ""
                }`}
              disabled={resetPasswordRes?.loading}
            >
              {resetPasswordRes?.loading ? "Processing..." : "Reset Password"}
            </button>
            <span
              className="p-link "
              onClick={() => {
                history.push("/");
              }}
            >
              Back to login
            </span>
          </div>
        </div>
      </form>
    </HomeWrapper>
  );
};

export default ResetPasswordForm;
